import React,{useState,useEffect}from 'react'
import { Table,Space, Radio,} from 'antd';
import BalanceTypeAdd from './BalanceTypeAdd';
import BalanceTypeEdit from './BalanceTypeEdit';
import BalanceTypeDel from './BalanceTypeDel';
import ModalType from '../../cpn/ModalType';
import { useFinanceSubTypeListQuery } from '../../store/BnsKeJiApi';
import Main from '../../cpn/Main';
import {balanceType} from './balanceType'
function BalanceTypeList() {   
    const [query,setQuery] = useState({efst_e_id:localStorage.getItem('e_id'),efst_finance_type_id:""})    
    const {data,isSuccess} = useFinanceSubTypeListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);                
                const newArr = data.Result.map(item => {
                    const {efst_id:key,efst_finance_type_id,efst_name,efst_content,efst_uname,efst_ctime,efst_update_ctime,efst_update_uname,num,ed_uname} = item;
                    return item = {key,efst_finance_type_id,efst_name,efst_content,efst_uname,efst_ctime,efst_update_ctime,efst_update_uname,num,ed_uname}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.efst_ctime;
                    let bTimeString = b.efst_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])     


    const columns = [    
        {
            key: 'type',
            title: '主类型名称',
            dataIndex: 'efst_finance_type_id',
            width:'10%',
            render:(text) => {
                const type = balanceType.filter(item => item.value===text);
                console.log(type);
                if(type[0]){
                    return <>{type[0].label}</>
                }else{
                    return<></>
                }
            }
        },                                          
        {
            key: 'type',
            title: '收支类型',
            dataIndex: 'efst_name',
            width:'10%',
            render:(text,record) => {
                return  <ModalType text={text} record={record} title={''}/>
            }
        },                                          
                                        
        {
            key: 'num',
            title: '收支数量',
            dataIndex: 'num',
            width:'10%',
        },   
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',
            width:'10%',
        },                                            
        {
            key: 'ed_uname',
            title: '部门',
            dataIndex: 'ed_uname',
            width:'10%',
        },                                            
        // {
        //     key: 'time',
        //     title: '操作记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>新建时间：{record.efst_ctime + record.efst_uname}</div>
        //             <div>修改时间：{record.efst_update_ctime + record.efst_update_uname}</div>
        //         </>
        //     },
        //     width:'10%',
        // },
        {
            key: 'action',
            width:'10%',
            title: '操作',
            render: (_, record) => {                
                return <>
                    <Space>                        
                        <BalanceTypeEdit
                            efst_id={record.key}
                        />
                        <BalanceTypeDel efst_id={record.key} num={record.num}/>
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main t1='财务' t2='收支类型'>
            <Space size={20}>
                <BalanceTypeAdd />
                <Radio.Group
                    onChange={(e) => {
                        setQuery(prevState=>({
                            ...prevState,
                            efst_finance_type_id:e.target.value
                        }))
                    }}
                >
                    <Radio value=''>全部</Radio>
                    <Radio value='1'>销售收入</Radio>
                    <Radio value='2'>成本支出</Radio>
                    <Radio value='3'>费用支出</Radio>
                    <Radio value='4'>其他收入</Radio>
                    <Radio value='5'>其他支出</Radio>
                </Radio.Group>
            </Space>
            <Table 
                columns={columns} 
                dataSource={list} 
                style={{marginTop:"10px"}}
                pagination={{
                    pageSize:50,
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                }}  
            />
        </Main>
    )
}

export default BalanceTypeList